import { render, staticRenderFns } from "./liveView.vue?vue&type=template&id=5843624c"
import script from "./liveView.vue?vue&type=script&lang=js"
export * from "./liveView.vue?vue&type=script&lang=js"
import style0 from "./liveView.vue?vue&type=style&index=0&id=5843624c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports